import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { RoleRepository } from '@domain/user/role.repository';
import { Role } from '@domain/user/role';
import { RoleMapper } from '@infrastructure/api/mappers/role.mapper';
import { RoleResponseDto } from '@infrastructure/api/dtos/role/role.response.dto';

@Injectable({ providedIn: 'root' })
export class RoleHttpRepository extends RoleRepository {
  private readonly url = `${environment.apiUrl}/roles`;

  constructor(private readonly http: HttpClient) {
    super();
  }

  getAll(): Observable<Role[]> {
    return this.http.get<RoleResponseDto[]>(this.url).pipe(
      map(RoleMapper.toDomainList)
    );
  }
}
